import * as React from 'react';
import { SvgProps } from '../SvgGetter/SvgGetter';
import { Colors } from '../../../../styles/colors';

export const Telehiv: React.FC<SvgProps> = ({
	fill = 'white',
	pathFill = Colors.primaryTekst,
	stroke = Colors.primaryTekst,
	...props
}) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='100%'
		height='100%'
		viewBox='0 0 16 16'
		fill='none'
		{...props}
	>
		<path
			d='M4.1995 8.74062L7.4495 5.24062C7.59012 5.0875 7.79012 5 7.9995 5C8.20887 5 8.40575 5.0875 8.5495 5.24063L11.7995 8.74062C12.0807 9.04375 12.0651 9.51875 11.7589 9.8C11.4526 10.0813 10.9807 10.0656 10.6995 9.75937L8.7495 7.65937L8.7495 15.25C8.7495 15.6656 8.41512 16 7.9995 16C7.58387 16 7.2495 15.6656 7.2495 15.25L7.2495 7.65937L5.2995 9.75937C5.01825 10.0625 4.54325 10.0812 4.24012 9.8C3.937 9.51875 3.91825 9.04375 4.1995 8.74062Z'
			fill={pathFill}
		/>
		<path
			d='M1 3.25H3.33333C3.76607 3.25 4.18714 3.10964 4.53333 2.85L6.8 1.15C7.51111 0.616667 8.48889 0.616667 9.2 1.15L11.4667 2.85C11.8129 3.10964 12.2339 3.25 12.6667 3.25H15'
			stroke={stroke}
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);
